import { useNavigate } from 'react-router-dom';
import  NAV_LOGO  from '../assets/logos/World_O_Tutor.webp';
import { SEO } from '../components/SEO';

export default function PageNotFound() {
  const navigate = useNavigate();
  return (
    <>
    <SEO 
      title="404 - Page Not Found - WorldoTutor"
      description="The page you are looking for does not exist."
      keywords="404, page not found, error"
      url="/404"
      type="website"
      noIndex={true}
    />
    <div className="w-full min-h-screen bg-white flex items-center justify-center">
      <div className="flex flex-col items-center justify-center gap-7">
        <h1 className="text-2xl font-semibold">Page Not Found</h1>
        <p onClick={() => navigate(-1)} className="text-base underline underline-offset-1 text-primary cursor-pointer">
          Go Back
        </p>
        <img src={NAV_LOGO} alt="WorldOTutor logo" className="h-10" />
      </div>
    </div>
    </>
  );
}
